(function () {
    'use strict';

    angular
        .module('jotApp')
        .directive('deviceFilter', deviceFilter);

    function deviceFilter() {
        var directive = {
            restrict: 'E',
            scope: {
                filter: '&',
                deviceType: '&',
                deviceTypeVal: '&'
            },
            template:   '<div class="row">\n' +
            '    <div class="col-xs-12">\n' +
            '        <div class="portlet light filter-portlet bordered">\n' +
            '            <div class="portlet-body form">\n' +
            '                <form ng-submit="vm.submit()" class="horizontal-form">\n' +
            '                    <div class="form-body">\n' +
            '                       <div class="row">\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label for="field_type">Device Type</label>\n' +
            '                                       <ui-select ng-model="vm.deviceType" id="deviceType_field" theme="bootstrap">\n' +
            '                                       <ui-select-match\n' +
            '                                           placeholder="Select or search a device type...">\n' +
            '                                           {{$select.selected.deviceTypeName}}\n' +
            '                                       </ui-select-match>\n' +
            '                                       <ui-select-choices repeat="item in vm.tabDevicesTypes | filter: {deviceTypeName: $select.search}">\n' +
            '                                           <div ng-bind-html="item.deviceTypeName | highlight: $select.search"></div>\n' +
            '                                       </ui-select-choices>\n' +
            '                                       </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-2 inline-filter-button">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label class="control-label ng-scope" for="submit_field"></label>\n' +
            '                                    <button type="submit" id="submit_field" class="btn btn-primary">\n' +
            '                                        <span class="fa fa-filter"></span>&nbsp;<span translate="entity.action.filter">Filter</span>\n' +
            '                                    </button>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                       </div>\n' +
            '                    </div>\n' +
            '                </form>\n' +
            '            </div>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '</div>\n',
            controller: DeviceFilterController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    DeviceFilterController.$inject = ['TabDevicesTypes'];

    function DeviceFilterController(TabDevicesTypes) {
        var vm=this;
        TabDevicesTypes.query(onSuccess, onError);

        function onSuccess(data) {
            vm.tabDevicesTypes = data;
            vm.tabDevicesTypes.unshift(allDeviceTypes);
        }

        function onError(){}

        var allDeviceTypes = {
            id: -1,
            deviceTypeName: 'All'
        };

        vm.deviceType = +vm.deviceTypeVal() === -1 || vm.deviceTypeVal().id === -1 ? allDeviceTypes : vm.deviceTypeVal();

        vm.submit = function () {
            vm.filter({deviceType: vm.deviceType});
        };
    }
})();
